import React, { useState, useEffect, useContext } from 'react';
// import useLocalStorage from "use-local-storage";
// import { useCookies } from "react-cookie";
// import fetchOptionsBuilder from '../fetchOptionBuilder';
import { Dropdown } from 'primereact/dropdown';
import WorkflowContext from '../workflowContext';
// import { useLoaderData } from 'react-router-dom';

function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }


export default function WorkflowPicker({ setWorkflow }) {
    // const workflowOptions = useLoaderData();
    const [workflowOptions, setWorkflowOptions] = useState([]);
    // const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']);
    const workflow = useContext(WorkflowContext);

    const [apitoken, setApitoken] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('apitoken', null)
    );

    const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));    

    useEffect(() => {
        fetch(process.env.REACT_APP_WORKFLOW_API_PATH + `wfapi/workflow?userId=${getDataUserId}}`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Authorization': `Bearer ${apitoken}`
            }
        })
        .then(res => res.json())
        .then(data => {
            const wfOptions = [];
            data.filter(workflow => workflow.status === 'Success').forEach(workflow => {
                const workflowObj = {
                    label: workflow.name,
                    value: String(workflow.id)
                }
                wfOptions.push(workflowObj);
            })
            setWorkflowOptions(wfOptions);
        })
    }, []);

    return(
        <Dropdown 
            className="workflow-dropdown" 
            options={workflowOptions} 
            value={workflow} 
            onChange={(e) => setWorkflow(e.value)} 
            placeholder='Select Workflow'
        />   
    )

}

